<nav class="navbar navbar-expand-lg fixed-top py-2 navbar-antiqry">
  <div class="container">
    <a class="navbar-brand d-inline-flex align-items-center" routerLink="/" (click)="closeNavbar()">
      <img class="d-inline-block logo me-2" src="/static/assets/img/logoartiquary.png" alt="Antiqry Logo" />
      <div class="d-flex flex-column ms-2">
        <span class="logo-text">Antiqry</span>
        <span class="brand-tagline">{{ 'NAV.TAGLINE' | translate:'Living Provenance Registry' }}</span>
      </div>
    </a>

    <!-- Mobile Menu Toggle Button -->
    <button class="navbar-toggler border-0 p-2 shadow-none" type="button"
      data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" 
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="material-symbols-outlined nav-toggle-icon">menu</span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Desktop & Mobile Primary Navigation Links -->
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-3">
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/items/search" [queryParams]="{selling: 'false'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined nav-icon">museum</span>
            {{ 'NAV.COLLECTIONS' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/items/search" [queryParams]="{selling: 'true'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined nav-icon">storefront</span>
            {{ 'NAV.MARKETPLACE' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-custom" routerLink="/items/search" (click)="closeNavbar()">
            <span class="material-symbols-outlined nav-icon">explore</span>
            {{ 'NAV.EXPLORE' | translate }}
          </a>
        </li>
      </ul>

      <!-- Mobile Categories Shortcut (Visible on Phones & Tablets) -->
      <div class="d-lg-none mobile-categories-container mb-3 pb-3 border-bottom">
        <div class="mobile-section-header mb-2">{{ 'NAV.ASSET_CLASSES' | translate }}</div>
        <div class="d-flex flex-wrap gap-2">
          <a class="mobile-cat-chip" routerLink="/items/search" [queryParams]="{category: 'Antiques'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined chip-icon">museum</span> {{ 'CATEGORIES.Antiques' | translate }}
          </a>
          <a class="mobile-cat-chip" routerLink="/items/search" [queryParams]="{category: 'Art'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined chip-icon">palette</span> {{ 'CATEGORIES.Art' | translate }}
          </a>
          <a class="mobile-cat-chip" routerLink="/items/search" [queryParams]="{category: 'Watches & Horology'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined chip-icon">watch</span> {{ 'CATEGORIES.Watches & Horology' | translate }}
          </a>
          <a class="mobile-cat-chip" routerLink="/items/search" [queryParams]="{category: 'Jewellery & Gemstones'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined chip-icon">diamond</span> {{ 'CATEGORIES.Jewellery & Gemstones' | translate }}
          </a>
          <a class="mobile-cat-chip" routerLink="/items/search" [queryParams]="{category: 'Fossils & Natural History'}" (click)="closeNavbar()">
            <span class="material-symbols-outlined chip-icon">history_edu</span> {{ 'CATEGORIES.Fossils & Natural History' | translate }}
          </a>
        </div>
      </div>

      <!-- Auth Section -->
      <div *ngIf="{ user: loginStatus$ | async } as data" class="w-100-mobile">
        <!-- Logged-in State -->
        <ng-container *ngIf="data.user; else guestTemplate">
          
          <!-- DESKTOP BAR (lg screens and up) -->
          <div class="d-none d-lg-flex align-items-center gap-2">
            <a class="btn-antique-outline btn-sm" routerLink="/items/list" [title]="'NAV.CATALOG_OBJECT' | translate">
              <span class="material-symbols-outlined" style="font-size: 18px;">add_circle</span>
              {{ 'NAV.CATALOG_OBJECT' | translate }}
            </a>
            
            <a class="nav-link nav-link-custom" routerLink="/my-items" [title]="'NAV.MY_COLLECTION' | translate">
              <span class="material-symbols-outlined nav-icon">inventory_2</span>
              {{ 'NAV.MY_COLLECTION' | translate }}
            </a>

            <a class="nav-link nav-link-custom position-relative" routerLink="/offers" [title]="'NAV.OFFERS' | translate">
              <span class="material-symbols-outlined nav-icon">sync_alt</span>
              {{ 'NAV.OFFERS' | translate }}
            </a>

            <div class="dropdown">
              <a class="nav-link nav-link-custom d-flex align-items-center gap-1" routerLink="/profile" [title]="'NAV.PROFILE' | translate">
                <span class="material-symbols-outlined nav-icon">account_circle</span>
                <span class="user-display-name">{{ data.user.displayName || ('NAV.PROFILE' | translate) }}</span>
              </a>
            </div>

            <!-- Admin Portal Link -->
            <a *ngIf="(isAdmin$ | async) || authService.isAdmin()" class="btn-antique-outline btn-sm d-flex align-items-center gap-1" routerLink="/admin" title="Executive Admin Portal" style="border-color: #d4af37; color: #b89146; background: rgba(212, 175, 55, 0.08);">
              <span class="material-symbols-outlined nav-icon" style="font-size: 18px; color: #d4af37;">shield_person</span>
              <span style="font-weight: 700;">Admin</span>
            </a>

            <button class="btn btn-link text-muted p-1 ms-1" (click)="logout()" [title]="'NAV.SIGN_OUT' | translate">
              <span class="material-symbols-outlined" style="font-size: 20px;">logout</span>
            </button>
          </div>

          <!-- MOBILE MENU (Phones & Tablets < 992px) -->
          <div class="d-lg-none mobile-user-drawer">
            <!-- User Info Card -->
            <div class="mobile-user-card p-3 mb-3 rounded-3 d-flex align-items-center gap-3">
              <div class="avatar-circle">
                <span class="material-symbols-outlined" style="font-size: 24px;">person</span>
              </div>
              <div class="overflow-hidden flex-grow-1">
                <div class="fw-bold text-dark text-truncate" style="font-size: 0.95rem;">
                  {{ data.user.displayName || 'Collector' }}
                </div>
                <div class="small text-muted text-truncate" style="font-size: 0.8rem;">
                  {{ data.user.email }}
                </div>
                <span class="badge-provenance mt-1 d-inline-block" style="font-size: 0.65rem; padding: 2px 6px;">{{ 'NAV.VERIFIED_COLLECTOR' | translate }}</span>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex flex-column gap-1 mb-2">
              <a class="btn-antique-gold w-100 py-2 d-flex align-items-center justify-content-center gap-2 mb-2" routerLink="/items/list" (click)="closeNavbar()">
                <span class="material-symbols-outlined" style="font-size: 20px;">add_circle</span>
                {{ 'NAV.CATALOG_NEW_OBJECT' | translate }}
              </a>

              <a class="mobile-nav-link" routerLink="/my-items" (click)="closeNavbar()">
                <span class="material-symbols-outlined mobile-nav-icon">inventory_2</span>
                <div class="flex-grow-1">
                  <div class="mobile-nav-title">{{ 'NAV.MY_COLLECTION' | translate }}</div>
                  <div class="mobile-nav-sub">{{ 'NAV.MY_COLLECTION_SUB' | translate }}</div>
                </div>
                <span class="material-symbols-outlined text-muted" style="font-size: 18px;">chevron_right</span>
              </a>

              <a class="mobile-nav-link" routerLink="/offers" (click)="closeNavbar()">
                <span class="material-symbols-outlined mobile-nav-icon">sync_alt</span>
                <div class="flex-grow-1">
                  <div class="mobile-nav-title">{{ 'NAV.OFFERS' | translate }}</div>
                  <div class="mobile-nav-sub">{{ 'NAV.OFFERS_SUB' | translate }}</div>
                </div>
                <span class="material-symbols-outlined text-muted" style="font-size: 18px;">chevron_right</span>
              </a>

              <a class="mobile-nav-link" routerLink="/profile" (click)="closeNavbar()">
                <span class="material-symbols-outlined mobile-nav-icon">manage_accounts</span>
                <div class="flex-grow-1">
                  <div class="mobile-nav-title">{{ 'NAV.PROFILE' | translate }}</div>
                  <div class="mobile-nav-sub">{{ 'NAV.PROFILE_SUB' | translate }}</div>
                </div>
                <span class="material-symbols-outlined text-muted" style="font-size: 18px;">chevron_right</span>
              </a>

              <a *ngIf="(isAdmin$ | async) || authService.isAdmin()" class="mobile-nav-link text-warning" routerLink="/admin" (click)="closeNavbar()" style="background: rgba(212, 175, 55, 0.08); border-radius: 8px;">
                <span class="material-symbols-outlined mobile-nav-icon" style="color: #d4af37;">shield_person</span>
                <div class="flex-grow-1">
                  <div class="mobile-nav-title" style="color: #b89146; font-weight: 700;">Admin Portal</div>
                  <div class="mobile-nav-sub">Sales, profit, support cases & operations</div>
                </div>
                <span class="material-symbols-outlined text-warning" style="font-size: 18px;">chevron_right</span>
              </a>
            </div>

            <div class="pt-2 border-top">
              <button class="mobile-nav-link text-danger w-100 border-0 bg-transparent text-start" (click)="logout()">
                <span class="material-symbols-outlined mobile-nav-icon text-danger">logout</span>
                <div class="flex-grow-1">
                  <div class="mobile-nav-title text-danger">{{ 'NAV.SIGN_OUT' | translate }}</div>
                </div>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Guest State (Not Logged In) -->
        <ng-template #guestTemplate>
          <!-- Desktop Guest -->
          <div class="d-none d-lg-flex align-items-center gap-2">
            <a class="btn-antique-outline btn-sm me-2" routerLink="/auth/login">
              {{ 'NAV.SIGN_IN' | translate }}
            </a>
            <a class="btn-antique-gold btn-sm" routerLink="/auth/sign-up">
              {{ 'NAV.JOIN_REGISTRY' | translate }}
            </a>
          </div>

          <!-- Mobile Guest -->
          <div class="d-lg-none mobile-guest-drawer pt-2">
            <a class="btn-antique-gold w-100 py-2 text-center mb-2" routerLink="/auth/sign-up" (click)="closeNavbar()">
              {{ 'NAV.JOIN_REGISTRY' | translate }}
            </a>
            <a class="btn-antique-outline w-100 py-2 text-center" routerLink="/auth/login" (click)="closeNavbar()">
              {{ 'NAV.SIGN_IN' | translate }}
            </a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</nav>
